export default __webpack_public_path__ + "static/media/file-image_lightGray3.4bcb0748.svg";